// Fichier généré par scripts/write-version.mjs — ne pas modifier.
export const buildInfo = {
  "version": "2.44.0",
  "commit": "31baa274",
  "buildId": "2.44.0+31baa274",
  "builtAt": "2026-10-27T15:48:46.472Z"
} as const;
